import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { NavBar } from './components/NavBar';
import { HeroSection } from './components/HeroSection';
import { TrustStrip } from './components/TrustStrip';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { OfferStack } from './components/OfferStack';
import { FAQSection } from './components/FAQSection';
import { GuaranteeBlock } from './components/GuaranteeBlock';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-deep font-sans text-body selection:bg-amber/30 selection:text-white" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <NavBar data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <TrustStrip data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <SolutionSection data-id="element-7" />
        <OfferStack data-id="element-8" />
        <FAQSection data-id="element-9" />
        <GuaranteeBlock data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}